import _ from 'lodash'
import clx from 'classnames'
import { FORM_ERROR_CLASS_NAME } from '../../../../../styles/variables'
import Tip from '../../../Common/Tip'
import { PRODUCTS_MAX_SIZE } from '../constants'
import styles from './index.css'

const validate = (getOverLimitError) => {
  const productsOverLimitMsg = getOverLimitError()
  if (!_.isEmpty(productsOverLimitMsg)) {
    return productsOverLimitMsg
  }

  return null
}

const EditModeTableTip = props => {
  const {
    isTwoLayerAttr,
    isDuplicatedProductExist,
    form: {
      listing: {
        listingSpecName: specName,
        listingItemSpecName: itemSpecName
      } = {}
    } = {},
    className,
    getOverLimitError,
    ...restProps
  } = props
  const errorMessage = validate(getOverLimitError)
  const isErrorMsgExist = !_.isEmpty(errorMessage)

  return (
    <>
      <Tip
        className={clx(
          className,
          styles.tableTip,
          { [styles.tableTipErrorMsg]: isErrorMsgExist },
          { [FORM_ERROR_CLASS_NAME]: isErrorMsgExist }
        )}
        {...restProps}
      >
        {
          isTwoLayerAttr
            ? `最多 ${PRODUCTS_MAX_SIZE.TWO_LAYER.PARENT_ATTR} 組${specName} x ${PRODUCTS_MAX_SIZE.ONE_LAYER.ATTR} 組${itemSpecName}`
            : specName
              ? `最多 ${PRODUCTS_MAX_SIZE.ONE_LAYER.ATTR} 組${specName}`
              : null
        }
        {
          isErrorMsgExist && (
            <>
              <span className={styles.separator}>|</span>
              {errorMessage}
            </>
          )
        }
        {
          isDuplicatedProductExist && (
            <>
              <span className={styles.separator}>|</span>
              <span className='duplicatedSkusStr'>重複商品已自動移除</span>
            </>
          )
        }
      </Tip>
    </>
  )
}

export default EditModeTableTip
